export const PORTAL_USER_TYPE = {
  PATIENT: "healthie-patient-user",
  COACHING: "coaching-user",
  ADMIN: "admin-user",
} as const;
